import { NgModule } from '@angular/core';
import { PreloadAllModules, Routes, RouterModule } from '@angular/router';

import { MainComponent } from './pages/main/main.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';

const routes: Routes = [
  { path: '', component: MainComponent, data: {
    keywords: 'Минск погода, прогноз погоды, метеопрогноз, погода в Беларуси, радарные карты, спутниковые снимки, фактическая погода, штормовые предупреждения',
    description: 'Национальная метеослужба Республики Беларусь. Прогноз погоды в Минске, Беларусь на 3 дня. Карты погоды и метеограммы, штормпредупреждения и метеоновости. Метеорологические и радарные карты. Спутниковые снимки.',
    classification: 'Погода. Беларусь. Фактическая погода Минск и прогноз погоды на 3 дня'
  } },
  // { path: 'account', loadChildren: () => import('./modules/account/account.module').then(mod => mod.AccountModule) },
  { path: 'information', loadChildren: () => import('./modules/information/information.module').then(mod => mod.InformationModule) },
  { path: 'services', loadChildren: () => import('./modules/services/services.module').then(mod => mod.ServicesModule) },
  { path: 'observation', loadChildren: () => import('./modules/observation/observation.module').then(mod => mod.ObservationModule) },
  { path: 'weather', loadChildren: () => import('./modules/weather/weather.module').then(mod => mod.WeatherModule) },
  { path: 'projects', loadChildren: () => import('./modules/projects/projects.module').then(mod => mod.ProjectsModule) },
  { path: 'page-not-found', component: NotFoundComponent },
  { path: '**', redirectTo: 'page-not-found' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes,{enableTracing: false,onSameUrlNavigation: 'reload'})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
